import React from "react";
import { CarouselComponent } from "../index";
import { useCurrentWidth } from "../../assets/utils/hooks";

export default function ParentElement(children, dataLength, checkLength) {
	const width = useCurrentWidth();

	const condition = checkLength ? dataLength < 2 : width > 768;

	if (condition) {
		return <ul className="section-cards--straight">{children}</ul>;
	} else {
		return (
			<CarouselComponent controls whiteControls>
				{children}{" "}
			</CarouselComponent>
		);
	}
}
